import { FileData } from "src/app/public/common/models/file-data.model";
import { ImageFolder } from "src/app/public/common/models/string-data.model";


export class FilesStoreUtils{

    
    public static addImageToCarImageFolder = ( imageFolders: ImageFolder[],  carId: string, image: Blob ) => {
        return imageFolders.map ( imageFolder => {
            let temp = Object.assign({}, imageFolder)
            if(temp.carId === carId) {
                console.log("adding images to folder of car id = "+temp.carId );
                temp.blobs = [];
                temp.blobs.push(image);
            }
            return temp;
        });
    }

    public static checkIfCarImageAlreadyDownloaded = ( imagesFolders: Map<string, Array<FileData>>,  carId: string, filename: string ): boolean => {
        
        if (imagesFolders.has(carId)){

            let temp = new Map(imagesFolders);
            
            let i: number = 0;
            let n = temp.get(carId)?.length!;

            while(i < n) {
                if( temp.get(carId)?.at(i)!.filename === filename ){
                    console.log('image with filename = '+filename+ ' is already downloaded');
                    return true;
                    
                }
                i++;
            }
            console.log(+filename+ ' is not already downloaded - folder not empty');
            return false;

        }
        else { 
            console.log(+filename+ ' is not already downloaded - folder empty');
            return false;
        }
    }

    
    public static addImageToCarImagesFolders = ( imagesFolders: Map<string, Array<FileData>>,  carId: string, imageDatas: FileData ) => {
        

        if (imagesFolders.has(carId)){

            let temp = new Map(imagesFolders);

            temp.get(carId)?.push(imageDatas);
            console.log('after = '+temp.get(carId)?.at(0)!);
            
    
            return temp;

        }
        else {
            //console.log('imagesFolders map has not before = '+imagesFolders.get(carId)?.length);
            let temp = new Map(imagesFolders);
            //console.log('during = '+temp.get(carId)?.length);
            temp.set(carId, [imageDatas]);
            //console.log('after = '+temp.get(carId)?.length);
    
            return temp;

        }

        //let temp: Map<string, Blob[]> = Object.assign({}, imagesFolders);
       
    }

    public static addDocumentToCarDocumentsFolders = ( documentsFolders: Map<string, Array<FileData>>,  carId: string, documentDatas: FileData ) => {
        

        if (documentsFolders.has(carId)){

            let temp = new Map(documentsFolders);

            temp.get(carId)?.push(documentDatas);
            console.log('after = '+temp.get(carId)?.at(0)!);
            
    
            return temp;

        }
        else {
            //console.log('imagesFolders map has not before = '+imagesFolders.get(carId)?.length);
            let temp = new Map(documentsFolders);
            //console.log('during = '+temp.get(carId)?.length);
            temp.set(carId, [documentDatas]);
            //console.log('after = '+temp.get(carId)?.length);
    
            return temp;

        }

        //let temp: Map<string, Blob[]> = Object.assign({}, imagesFolders);
       
    }

    public static addImageToCarImageSamples = ( imageSamples: Map<string, Blob>,  filename: string, blob: Blob ) => {
        
        // let temp = new Map(imageSamples);
        // temp.set(filename, blob);
        // return temp; 

        if (imageSamples.has(filename)){

            let temp = new Map(imageSamples);
            console.log('++++adding finame = '+filename);
            temp.delete(filename);

            temp.set(filename, blob);
           
            return temp;

        }
        else {
            console.log('++adding finame = '+filename);
            let temp = new Map(imageSamples);
            //console.log('during = '+temp.get(carId)?.length);
            temp.set(filename, blob);
            //console.log('after = '+temp.get(carId)?.length);
            return temp;

        }
    }
    

}
